import { SELLER_TYPES } from '../containers/PaymentCalculator/calculationEngine';

/**
 * Predicates for the listing's publicData.sellerType.
 *
 * An unset seller type is never treated as a private sale. Several behaviours
 * key off "private" -- the payout-details exemption, the transaction process a
 * new listing gets -- and inferring one from missing data would apply them to
 * listings nobody made that claim about.
 */

export const isPrivateSellerType = sellerType => sellerType === SELLER_TYPES.private;

export const isPrivateSellerListing = listing =>
  isPrivateSellerType(listing?.attributes?.publicData?.sellerType);
